import React from "react";
import { FilterListItem } from "./FilterListItem";

const textMatch = (needle, haystack) =>
  haystack
    .toLowerCase()
    .replace(" ", "")
    .indexOf(needle.toLowerCase().replace(" ", "")) !== -1;

export const FilterPopup = ({
  searchValue,
  filterGroups,
  activeFilters,
  handleOnGroupFilterClick,
  filterList,
  handleOnFilterClick,
  updateSearchValue,
  removeActiveFilters,
  isActive,
  setIsActive
}) => {
  return (
    <div className={`filterPopup ${isActive ? "active" : ""}`}>
      <div className="filterPopup__header">
        <i className="fal fa-filter"></i>
        <h3>Filters</h3>
        <button
          className="btn removeFilters"
          onClick={() => removeActiveFilters()}
        >
          Filters wissen
        </button>
        <button
          className="btn filterPopup__closeBtn"
          onClick={() => setIsActive(false)}
        >
          <i className="fal fa-times"></i>
          <span className="screen-reader-text">Popup sluiten</span>
        </button>
      </div>
      <div className="filterPopup__search">
        <div className="container">
          <i className="fal fa-search"></i>
          <label className="screen-reader-text">Zoek filters</label>
          <input
            type="search"
            value={searchValue}
            placeholder="Welke dag of periode zoek je?"
            onChange={e => updateSearchValue(e.target.value)}
          />
        </div>
      </div>
      <div className="filterPopup__body container">
        <div className="filterPopup__filterList">
          {searchValue.length === 0 &&
            filterGroups.map(group => {
              return (
                <FilterListItem
                  key={`group_${group.id}`}
                  id={group.id}
                  idPrefix="group_"
                  title={group.title}
                  onClick={handleOnGroupFilterClick}
                  checked={group.checked}
                />
              );
            })}

          <span
            style={{
              width: "100%",
              height: 1,
              margin: "1rem 0",
              background: "#e2e3e5",
              display: "block"
            }}
          />

          {filterList.map(filter => {
            if (parseInt(filter.id) === 0) return null;
            return (
              <FilterListItem
                key={`filter_${filter.id}`}
                id={filter.id}
                idPrefix="filter_"
                title={filter.title}
                checked={filter.checked}
                onClick={handleOnFilterClick}
              />
            );
          })}
        </div>
      </div>
      <div className="filterPopup__footer">
        {/* <button className="btn">Annuleren</button> */}
        <button className="btn btn-primary" onClick={() => setIsActive(false)}>
          Filters toepassen
        </button>
      </div>
    </div>
  );
};
